// Express Single Coding Upload: a schedule entry picked from the search belongs to the
// schedule feed, so the upload only attaches to it. The job still takes the provider picked
// for the upload; saving the entry would replace its Primary with that provider (Bug 6307).
// Only an entry typed in by hand (Id 0) is saved as a new schedule entry.
export const savesScheduleEntry = (appointment) => !(appointment && Number(appointment.Id) > 0);



// WEBPACK FOOTER //
// ./src/components/expressScheduleEntry.js